<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />
    <!-- Breadcrumb -->
    <div class="mb-3 row">
      <div class="col-11">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link v-if="p_idPerfil == 18 || p_idPerfil == 20" to="/tramite-asignados">Trámites</router-link>
              <router-link v-else to="/tramite">Trámites</router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'TramiteForm', params: { p_idtramite } }">
                Trámite N.° {{ p_idtramite }}
              </router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'TramiteForm',
                                  params: { p_idtramite, },
                                  query: { tab: 'reportes' } }">
                Reportes
              </router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">Observaciones y Respuestas</li>
          </ol>
        </nav>
      </div>
      <div class="col-1 text-end">
        <span class="material-symbols-outlined text-primary"
          style="font-size: 32px; cursor: pointer" @click="showModalHelp = true">
          help
        </span>
      </div>
    </div>

    <div class="card border-0 mb-3" style="background-color: #e8f4fd;">
      <div class="card-body py-2 px-3">
        <span class="text-dark fw-bold">{{ datosTramite }}</span>
      </div>
    </div>

    <!-- Tabs -->
    <ul class="nav nav-tabs mb-3">
      <li class="nav-item" v-for="tab in tabs" :key="tab">
        <a class="nav-link" :class="{ active: activeTab === tab }"
          href="#" @click.prevent="activeTab = tab">
          {{ tab }}
        </a>
      </li>
    </ul>

    <!-- Barra de acciones -->
<div class="row g-2 mb-3 align-items-end">
  <div class="col-auto d-flex flex-column justify-content-center">
    <label class="form-label mb-1 small fw-bold">Tipo de observación</label>
    <select
      v-model="filtros.observacionTipo"
      class="form-select form-select-sm"
      @change="buscarDatos"
    >
      <option value="">Todos</option>
      <option value="M">Auditoría Médica</option>
      <option value="D">Gestión Documental</option>
    </select>
  </div>

  <div class="col-auto d-flex align-items-end">
    <button
      @click="exportToExcel"
      class="btn btn-info btn-sm d-flex align-items-center gap-1"
    >
      <span class="material-icons" style="font-size: 16px">download</span>
      Excel
    </button>
  </div>
</div>

    <!-- Cargando -->
    <div v-if="cargando" class="alert alert-info py-2 px-3" role="alert">
      Cargando datos...
    </div>

    <!-- ══════════════════════════════════════════════════════ -->
    <!-- Tab: Observaciones combinadas                         -->
    <!-- ══════════════════════════════════════════════════════ -->
    <div v-else-if="activeTab === 'Observaciones combinadas'">

      <!-- Observaciones generales -->
      <h6 class="fw-bold mb-2">Observaciones generales</h6>
      <div class="table-responsive" v-if="resultadosGenerales.length > 0">
        <table class="table table-hover table-bordered table-sm">
          <thead class="table-dark">
            <tr>
              <th class="th-sort" @click="ordenarPor('generales', 'planillaNumero')">
                Planilla <span>{{ iconOrden('generales', 'planillaNumero') }}</span>
              </th>
              <th>Código</th>
<!--
              <th class="th-sort" @click="ordenarPor('generales', 'observacionTipo')">
                Tipo <span>{{ iconOrden('generales', 'observacionTipo') }}</span>
              </th>
-->
              <th class="th-sort" @click="ordenarPor('generales', 'observacionDescripcion')">
                Observación estándar
                <span>{{ iconOrden('generales', 'observacionDescripcion') }}</span>
              </th>
              <th class="th-sort" @click="ordenarPor('generales', 'descripcion')">
                Obs. complementaria <span>{{ iconOrden('generales', 'descripcion') }}</span>
              </th>
<!--			  
              <th class="th-sort" @click="ordenarPor('generales', 'estadoAud')">
                Estado AM <span>{{ iconOrden('generales', 'estadoAud') }}</span>
              </th>
              <th class="th-sort" @click="ordenarPor('generales', 'estadoDoc')">
                Estado GD <span>{{ iconOrden('generales', 'estadoDoc') }}</span>
              </th>
-->
              <th class="th-sort" @click="ordenarPor('generales', 'respuestaDescripcion')">
                Resp. estándar
                <span>{{ iconOrden('generales', 'respuestaDescripcion') }}</span>
              </th>
              <th class="th-sort" @click="ordenarPor('generales', 'respuesta')">
                Resp. compl.<span>{{ iconOrden('generales', 'respuesta') }}</span>
              </th>
              <th class="th-sort" @click="ordenarPor('generales', 'respuesta')">
                Resp.<span>{{ iconOrden('generales', 'respuesta') }}</span>
              </th>
              <th class="th-sort" @click="ordenarPor('generales', 'revisado')">
                Justificado <span>{{ iconOrden('generales', 'revisado') }}</span>
              </th>
              <th>Acción</th>
            </tr>
            <tr>
              <th>
                <input v-model="filtrosColumna.generales.planilla"
                  @input="resetPagina('generales')"
                  class="form-control form-control-sm" placeholder="Filtrar..." />
              </th>
              <th></th>
<!--
              <th>
                <input v-model="filtrosColumna.generales.observacionTipo"
                  @input="resetPagina('generales')"
                  class="form-control form-control-sm" placeholder="Filtrar..." />
              </th>
-->
              <th>
                <input v-model="filtrosColumna.generales.obsEstandar"
                  @input="resetPagina('generales')"
                  class="form-control form-control-sm" placeholder="Filtrar..." />
              </th>
              <th>
                <input v-model="filtrosColumna.generales.obsComplementaria"
                  @input="resetPagina('generales')"
                  class="form-control form-control-sm" placeholder="Filtrar..." />
              </th>
<!--
              <th>
                <select v-model="filtrosColumna.generales.estadoAud"
                  @change="resetPagina('generales')" class="form-select form-select-sm">
                  <option value="">Todos</option>
                  <option value="PENDIENTE">PENDIENTE</option>
                  <option value="REVISADA">REVISADA</option>
                  <option value="FINALIZADA">FINALIZADA</option>
                </select>
              </th>
              <th>
                <select v-model="filtrosColumna.generales.estadoDoc"
                  @change="resetPagina('generales')" class="form-select form-select-sm">
                  <option value="">Todos</option>
                  <option value="PENDIENTE">PENDIENTE</option>
                  <option value="REVISADA">REVISADA</option>
                  <option value="FINALIZADA">FINALIZADA</option>
                </select>
              </th>
-->
              <th>
                <input v-model="filtrosColumna.generales.respuestaDescripcion"
                  @input="resetPagina('generales')"
                  class="form-control form-control-sm" placeholder="Filtrar..." />
              </th>
              <th>
                <input v-model="filtrosColumna.generales.respuesta"
                  @input="resetPagina('generales')"
                  class="form-control form-control-sm" placeholder="Filtrar..." />
              </th>
              <th>
                <select v-model="filtrosColumna.generales.respondida"
                  @change="resetPagina('generales')" class="form-select form-select-sm">
                  <option value="">Todos</option>
                  <option value="1">Sí</option>
                  <option value="0">No</option>
                </select>
              </th>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="r in pagedGenerales" :key="r.idPlaObs"
                @dblclick="handleRowClick($event, r.idPlanilla)">
              <td>{{ r.planillaNumero }}</td>
              <td></td>
<!--
              <td>{{ r.observacionTipo }}</td>
-->
              <td>{{ r.observacionDescripcion }}</td>
              <td>{{ r.descripcion }}</td>
<!--
              <td>{{ r.estadoAud }}</td>
              <td>{{ r.estadoDoc }}</td>
-->
              <td>{{ r.respuestaDescripcion }}</td>
              <td>{{ r.respuesta }}</td>
              <td class="text-center">
                <span v-if="r.respuestaDescripcion" class="material-icons text-success"
                  style="font-size: 18px" title="Respondida">check_circle</span>
                <span v-else class="material-icons text-danger"
                  style="font-size: 18px" title="Sin respuesta">cancel</span>
              </td>
              <td class="text-center">
                <span v-if="r.revisado == 1" class="material-icons text-success"
                  style="font-size: 18px">check_circle</span>
              </td>
              <td>
                <button class="btn btn-outline-primary btn-sm"
                  @click.stop="marcarRevisado('generales', r.idPlaObs)"
                  title="Marcar como revisado">
                  <span class="material-icons" style="font-size: 16px">task_alt</span>
                </button>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr class="table-secondary">
              <td colspan="9" class="text-end fw-bold small">
                Mostrando {{ pagedGenerales.length }} de
                {{ generalesFiltrados.length }} registros
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
      <div v-else class="alert alert-warning mt-2 mb-4">
        No se encontraron observaciones generales.
      </div>

      <!-- Control registros por página - generales -->
      <div class="d-flex align-items-center gap-2 mb-2" v-if="generalesFiltrados.length > 0">
        <label class="form-label mb-0 small fw-bold">Mostrar</label>
        <select v-model.number="itemsPerPage" class="form-select form-select-sm"
          style="width: 75px" @change="resetPagina('generales')">
          <option :value="5">5</option>
          <option :value="10">10</option>
          <option :value="25">25</option>
          <option :value="50">50</option>
          <option :value="100">100</option>
        </select>
        <span class="small text-muted">registros</span>
      </div>

      <!-- Paginación generales -->
      <div class="d-flex justify-content-between align-items-center mt-2 mb-4"
        v-if="generalesFiltrados.length > 0">
        <span class="small text-muted">
          Página {{ currentPageGenerales }} de {{ totalPagesGenerales }} —
          {{ generalesFiltrados.length }} registros
        </span>
        <nav>
          <ul class="pagination pagination-sm mb-0">
            <li class="page-item" :class="{ disabled: currentPageGenerales === 1 }">
              <a class="page-link" href="#" @click.prevent="currentPageGenerales = 1">«</a>
            </li>
            <li class="page-item" :class="{ disabled: currentPageGenerales === 1 }">
              <a class="page-link" href="#" @click.prevent="currentPageGenerales--">‹</a>
            </li>
            <li v-for="pagina in paginasVisibles('generales')" :key="pagina"
              class="page-item"
              :class="{ active: pagina === currentPageGenerales, disabled: pagina === '...' }">
              <a class="page-link" href="#"
                @click.prevent="pagina !== '...' && (currentPageGenerales = pagina)">
                {{ pagina }}
              </a>
            </li>
            <li class="page-item" :class="{ disabled: currentPageGenerales === totalPagesGenerales }">
              <a class="page-link" href="#" @click.prevent="currentPageGenerales++">›</a>
            </li>
            <li class="page-item" :class="{ disabled: currentPageGenerales === totalPagesGenerales }">
              <a class="page-link" href="#"
                @click.prevent="currentPageGenerales = totalPagesGenerales">»</a>
            </li>
          </ul>
        </nav>
      </div>

      <!-- Observaciones detalle -->
      <h6 class="fw-bold mb-2">Observaciones detalle</h6>
      <div class="table-responsive" v-if="resultadosDetalle.length > 0">
        <table class="table table-hover table-bordered table-sm">
          <thead class="table-dark">
            <tr>
              <th class="th-sort" @click="ordenarPor('detalle', 'planillaNumero')">
                Planilla <span>{{ iconOrden('detalle', 'planillaNumero') }}</span>
              </th>
              <th class="th-sort" @click="ordenarPor('detalle', 'elementoCodigo')">
                Código <span>{{ iconOrden('detalle', 'elementoCodigo') }}</span>
              </th>
<!--
              <th class="th-sort" @click="ordenarPor('detalle', 'observacionTipo')">
                Tipo <span>{{ iconOrden('detalle', 'observacionTipo') }}</span>
              </th>
-->
              <th class="th-sort" @click="ordenarPor('detalle', 'observacionDescripcion')">
                Observación estándar
                <span>{{ iconOrden('detalle', 'observacionDescripcion') }}</span>
              </th>
              <th class="th-sort" @click="ordenarPor('detalle', 'descripcion')">
                Obs. complementaria <span>{{ iconOrden('detalle', 'descripcion') }}</span>
              </th>
<!--
              <th class="th-sort" @click="ordenarPor('detalle', 'estadoAud')">
                Estado AM <span>{{ iconOrden('detalle', 'estadoAud') }}</span>
              </th>
              <th class="th-sort" @click="ordenarPor('detalle', 'estadoDoc')">
                Estado GD <span>{{ iconOrden('detalle', 'estadoDoc') }}</span>
              </th>
-->
              <th class="th-sort" @click="ordenarPor('detalle', 'respuestaDescripcion')">
                Resp. estándar
                <span>{{ iconOrden('detalle', 'respuestaDescripcion') }}</span>
              </th>
              <th class="th-sort" @click="ordenarPor('detalle', 'respuesta')">
                Resp. compl.<span>{{ iconOrden('detalle', 'respuesta') }}</span>
              </th>
              <th class="th-sort" @click="ordenarPor('detalle', 'respuesta')">
                Resp.<span>{{ iconOrden('detalle', 'respuesta') }}</span>
              </th>
              <th class="th-sort" @click="ordenarPor('detalle', 'revisado')">
                Justificado <span>{{ iconOrden('detalle', 'revisado') }}</span>
              </th>
              <th>Acción</th>
            </tr>
            <tr>
              <th>
                <input v-model="filtrosColumna.detalle.planilla"
                  @input="resetPagina('detalle')"
                  class="form-control form-control-sm" placeholder="Filtrar..." />
              </th>
              <th>
                <input v-model="filtrosColumna.detalle.codigo"
                  @input="resetPagina('detalle')"
                  class="form-control form-control-sm" placeholder="Filtrar..." />
              </th>
<!--
              <th>
                <input v-model="filtrosColumna.detalle.observacionTipo"
                  @input="resetPagina('detalle')"
                  class="form-control form-control-sm" placeholder="Filtrar..." />
              </th>
-->
              <th>
                <input v-model="filtrosColumna.detalle.obsEstandar"
                  @input="resetPagina('detalle')"
                  class="form-control form-control-sm" placeholder="Filtrar..." />
              </th>
              <th>
                <input v-model="filtrosColumna.detalle.obsComplementaria"
                  @input="resetPagina('detalle')"
                  class="form-control form-control-sm" placeholder="Filtrar..." />
              </th>
<!--
              <th>
                <select v-model="filtrosColumna.detalle.estadoAud"
                  @change="resetPagina('detalle')" class="form-select form-select-sm">
                  <option value="">Todos</option>
                  <option value="PENDIENTE">PENDIENTE</option>
                  <option value="REVISADA">REVISADA</option>
                  <option value="FINALIZADA">FINALIZADA</option>
                </select>
              </th>
              <th>
                <select v-model="filtrosColumna.detalle.estadoDoc"
                  @change="resetPagina('detalle')" class="form-select form-select-sm">
                  <option value="">Todos</option>
                  <option value="PENDIENTE">PENDIENTE</option>
                  <option value="REVISADA">REVISADA</option>
                  <option value="FINALIZADA">FINALIZADA</option>
                </select>
              </th>
-->
              <th>
                <input v-model="filtrosColumna.detalle.respuestaDescripcion"
                  @input="resetPagina('detalle')"
                  class="form-control form-control-sm" placeholder="Filtrar..." />
              </th>
              <th>
                <input v-model="filtrosColumna.detalle.respuesta"
                  @input="resetPagina('detalle')"
                  class="form-control form-control-sm" placeholder="Filtrar..." />
              </th>
              <th>
                <select v-model="filtrosColumna.detalle.respondida"
                  @change="resetPagina('detalle')" class="form-select form-select-sm">
                  <option value="">Todos</option>
                  <option value="1">Sí</option>
                  <option value="0">No</option>
                </select>
              </th>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="r in pagedDetalle" :key="r.idPlaDetObs"
                @dblclick="handleRowClick($event, r.idPlanilla)">
              <td>{{ r.planillaNumero }}</td>
              <td>{{ r.elementoCodigo }}</td>
<!--
              <td>{{ r.observacionTipo }}</td>
-->
              <td>{{ r.observacionDescripcion }}</td>
              <td>{{ r.descripcion }}</td>
<!--
              <td>{{ r.estadoAud }}</td>
              <td>{{ r.estadoDoc }}</td>
-->
              <td>{{ r.respuestaDescripcion }}</td>
              <td>{{ r.respuesta }}</td>
              <td class="text-center">
                <span v-if="r.respuestaDescripcion" class="material-icons text-success"
                  style="font-size: 18px" title="Respondida">check_circle</span>
                <span v-else class="material-icons text-danger"
                  style="font-size: 18px" title="Sin respuesta">cancel</span>
              </td>
              <td class="text-center">
                <span v-if="r.revisado == 1" class="material-icons text-success"
                  style="font-size: 18px">check_circle</span>
              </td>			  
              <td>
                <button class="btn btn-outline-primary btn-sm"
                  @click.stop="marcarRevisado('detalle', r.idPlaDetObs)"
                  title="Marcar como revisado">
                  <span class="material-icons" style="font-size: 16px">task_alt</span>
                </button>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr class="table-secondary">
              <td colspan="10" class="text-end fw-bold small">
                Mostrando {{ pagedDetalle.length }} de
                {{ detalleFiltrados.length }} registros
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
      <div v-else class="alert alert-warning mt-2">
        No se encontraron observaciones detalle.
      </div>

      <!-- Control registros por página - detalle -->
      <div class="d-flex align-items-center gap-2 mb-2" v-if="detalleFiltrados.length > 0">
        <label class="form-label mb-0 small fw-bold">Mostrar</label>
        <select v-model.number="itemsPerPage" class="form-select form-select-sm"
          style="width: 75px" @change="resetPagina('detalle')">
          <option :value="5">5</option>
          <option :value="10">10</option>
          <option :value="25">25</option>
          <option :value="50">50</option>
          <option :value="100">100</option>
        </select>
        <span class="small text-muted">registros</span>
      </div>

      <!-- Paginación detalle -->
      <div class="d-flex justify-content-between align-items-center mt-2"
        v-if="detalleFiltrados.length > 0">
        <span class="small text-muted">
          Página {{ currentPageDetalle }} de {{ totalPagesDetalle }} —
          {{ detalleFiltrados.length }} registros
        </span>
        <nav>
          <ul class="pagination pagination-sm mb-0">
            <li class="page-item" :class="{ disabled: currentPageDetalle === 1 }">
              <a class="page-link" href="#" @click.prevent="currentPageDetalle = 1">«</a>
            </li>
            <li class="page-item" :class="{ disabled: currentPageDetalle === 1 }">
              <a class="page-link" href="#" @click.prevent="currentPageDetalle--">‹</a>
            </li>
            <li v-for="pagina in paginasVisibles('detalle')" :key="pagina"
              class="page-item"
              :class="{ active: pagina === currentPageDetalle, disabled: pagina === '...' }">
              <a class="page-link" href="#"
                @click.prevent="pagina !== '...' && (currentPageDetalle = pagina)">
                {{ pagina }}
              </a>
            </li>
            <li class="page-item" :class="{ disabled: currentPageDetalle === totalPagesDetalle }">
              <a class="page-link" href="#" @click.prevent="currentPageDetalle++">›</a>
            </li>
            <li class="page-item" :class="{ disabled: currentPageDetalle === totalPagesDetalle }">
              <a class="page-link" href="#"
                @click.prevent="currentPageDetalle = totalPagesDetalle">»</a>
            </li>
          </ul>
        </nav>
      </div>
    </div>

    <!-- ══════════════════════════════════════════════════════ -->
    <!-- Tab: Generales o Detalle                              -->
    <!-- ══════════════════════════════════════════════════════ -->
    <div v-else>
      <div class="table-responsive" v-if="resultados.length > 0">
        <table class="table table-hover table-bordered table-sm">
          <thead class="table-dark">
            <tr>
              <th class="th-sort" @click="ordenarPor('main', 'planillaNumero')">
                Planilla <span>{{ iconOrden('main', 'planillaNumero') }}</span>
              </th>
              <th v-if="activeTab !== 'Observaciones generales'"
                class="th-sort" @click="ordenarPor('main', 'elementoCodigo')">
                Código <span>{{ iconOrden('main', 'elementoCodigo') }}</span>
              </th>
<!--
              <th class="th-sort" @click="ordenarPor('main', 'observacionTipo')">
                Tipo <span>{{ iconOrden('main', 'observacionTipo') }}</span>
              </th>
-->
              <th class="th-sort" @click="ordenarPor('main', 'observacionDescripcion')">
                Observación estándar
                <span>{{ iconOrden('main', 'observacionDescripcion') }}</span>
              </th>
              <th class="th-sort" @click="ordenarPor('main', 'descripcion')">
                Obs. complementaria <span>{{ iconOrden('main', 'descripcion') }}</span>
              </th>
<!--
              <th class="th-sort" @click="ordenarPor('main', 'estadoAud')">
                Estado AM <span>{{ iconOrden('main', 'estadoAud') }}</span>
              </th>
              <th class="th-sort" @click="ordenarPor('main', 'estadoDoc')">
                Estado GD <span>{{ iconOrden('main', 'estadoDoc') }}</span>
              </th>
-->
              <th class="th-sort" @click="ordenarPor('main', 'respuestaDescripcion')">
                Resp. estándar
                <span>{{ iconOrden('main', 'respuestaDescripcion') }}</span>
              </th>
              <th class="th-sort" @click="ordenarPor('main', 'respuesta')">
                Resp. compl.<span>{{ iconOrden('main', 'respuesta') }}</span>
              </th>
              <th class="th-sort" @click="ordenarPor('main', 'respuesta')">
                Resp.<span>{{ iconOrden('main', 'respuesta') }}</span>
              </th>
              <th class="th-sort" @click="ordenarPor('main', 'revisado')">
                Justificado <span>{{ iconOrden('main', 'revisado') }}</span>
              </th>
              <th>Acción</th>
            </tr>
            <tr>
              <th>
                <input v-model="filtrosColumna.main.planilla"
                  @input="resetPagina('main')"
                  class="form-control form-control-sm" placeholder="Filtrar..." />
              </th>
              <th v-if="activeTab !== 'Observaciones generales'">
                <input v-model="filtrosColumna.main.codigo"
                  @input="resetPagina('main')"
                  class="form-control form-control-sm" placeholder="Filtrar..." />
              </th>
<!--
              <th>
                <input v-model="filtrosColumna.main.observacionTipo"
                  @input="resetPagina('main')"
                  class="form-control form-control-sm" placeholder="Filtrar..." />
              </th>
-->
              <th>
                <input v-model="filtrosColumna.main.obsEstandar"
                  @input="resetPagina('main')"
                  class="form-control form-control-sm" placeholder="Filtrar..." />
              </th>
              <th>
                <input v-model="filtrosColumna.main.obsComplementaria"
                  @input="resetPagina('main')"
                  class="form-control form-control-sm" placeholder="Filtrar..." />
              </th>
<!--
              <th>
                <select v-model="filtrosColumna.main.estadoAud"
                  @change="resetPagina('main')" class="form-select form-select-sm">
                  <option value="">Todos</option>
                  <option value="PENDIENTE">PENDIENTE</option>
                  <option value="REVISADA">REVISADA</option>
                  <option value="FINALIZADA">FINALIZADA</option>
                </select>
              </th>
              <th>
                <select v-model="filtrosColumna.main.estadoDoc"
                  @change="resetPagina('main')" class="form-select form-select-sm">
                  <option value="">Todos</option>
                  <option value="PENDIENTE">PENDIENTE</option>
                  <option value="REVISADA">REVISADA</option>
                  <option value="FINALIZADA">FINALIZADA</option>
                </select>
              </th>
-->
              <th>
                <input v-model="filtrosColumna.main.respuestaDescripcion"
                  @input="resetPagina('main')"
                  class="form-control form-control-sm" placeholder="Filtrar..." />
              </th>
              <th>
                <input v-model="filtrosColumna.main.respuesta"
                  @input="resetPagina('main')"
                  class="form-control form-control-sm" placeholder="Filtrar..." />
              </th>
              <th>
                <select v-model="filtrosColumna.main.respondida"
                  @change="resetPagina('main')" class="form-select form-select-sm">
                  <option value="">Todos</option>
                  <option value="1">Sí</option>
                  <option value="0">No</option>
                </select>
              </th>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="r in pagedResultados" :key="r.idPlaObs || r.idPlaDetObs"
                @dblclick="handleRowClick($event, r.idPlanilla)">
              <td>{{ r.planillaNumero }}</td>
              <td v-if="activeTab !== 'Observaciones generales'">{{ r.elementoCodigo }}</td>
<!--
              <td>{{ r.observacionTipo }}</td>
-->
              <td>{{ r.observacionDescripcion }}</td>
              <td>{{ r.descripcion }}</td>
<!--
              <td>{{ r.estadoAud }}</td>
              <td>{{ r.estadoDoc }}</td>
-->
              <td>{{ r.respuestaDescripcion }}</td>
              <td>{{ r.respuesta }}</td>
              <td class="text-center">
                <span v-if="r.respuestaDescripcion" class="material-icons text-success"
                  style="font-size: 18px" title="Respondida">check_circle</span>
                <span v-else class="material-icons text-danger"
                  style="font-size: 18px" title="Sin respuesta">cancel</span>
              </td>
              <td class="text-center">
                <span v-if="r.revisado == 1" class="material-icons text-success"
                  style="font-size: 18px">check_circle</span>
              </td>
              <td>
                <button class="btn btn-outline-primary btn-sm"
                  @click.stop="marcarRevisado(
                    activeTab === 'Observaciones generales' ? 'generales' : 'detalle',
                    r.idPlaObs ?? r.idPlaDetObs
                  )"
                  title="Marcar como revisado">
                  <span class="material-icons" style="font-size: 16px">task_alt</span>
                </button>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr class="table-secondary">
              <td :colspan="activeTab === 'Observaciones generales' ? 9 : 10"
                class="text-end fw-bold small">
                Mostrando {{ pagedResultados.length }} de {{ mainFiltrados.length }} registros
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
      <div v-else class="alert alert-warning mt-3">No se encontraron resultados.</div>

      <!-- Control registros por página - main -->
      <div class="d-flex align-items-center gap-2 mb-2" v-if="mainFiltrados.length > 0">
        <label class="form-label mb-0 small fw-bold">Mostrar</label>
        <select v-model.number="itemsPerPage" class="form-select form-select-sm"
          style="width: 75px" @change="resetPagina('main')">
          <option :value="5">5</option>
          <option :value="10">10</option>
          <option :value="25">25</option>
          <option :value="50">50</option>
          <option :value="100">100</option>
        </select>
        <span class="small text-muted">registros</span>
      </div>

      <!-- Paginación principal -->
      <div class="d-flex justify-content-between align-items-center mt-3"
        v-if="mainFiltrados.length > 0">
        <span class="small text-muted">
          Página {{ currentPageMain }} de {{ totalPagesMain }} —
          {{ mainFiltrados.length }} registros
        </span>
        <nav>
          <ul class="pagination pagination-sm mb-0">
            <li class="page-item" :class="{ disabled: currentPageMain === 1 }">
              <a class="page-link" href="#" @click.prevent="currentPageMain = 1">«</a>
            </li>
            <li class="page-item" :class="{ disabled: currentPageMain === 1 }">
              <a class="page-link" href="#" @click.prevent="currentPageMain--">‹</a>
            </li>
            <li v-for="pagina in paginasVisibles('main')" :key="pagina"
              class="page-item"
              :class="{ active: pagina === currentPageMain, disabled: pagina === '...' }">
              <a class="page-link" href="#"
                @click.prevent="pagina !== '...' && (currentPageMain = pagina)">
                {{ pagina }}
              </a>
            </li>
            <li class="page-item" :class="{ disabled: currentPageMain === totalPagesMain }">
              <a class="page-link" href="#" @click.prevent="currentPageMain++">›</a>
            </li>
            <li class="page-item" :class="{ disabled: currentPageMain === totalPagesMain }">
              <a class="page-link" href="#"
                @click.prevent="currentPageMain = totalPagesMain">»</a>
            </li>
          </ul>
        </nav>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Layout from "@/components/Layout.vue";
import Footer from "@/components/Footer.vue";
import dateFormat from "@/modules/dateFormat.js";
import api from "@/services/api";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";

export default {
  name: "ObservacionesTabs",
  props: {
    p_idtramite:     { type: Number, required: true },
    p_idservicio:    { type: Number, required: true },
    p_estadoTramite: { type: String, required: true },
  },
  components: { Layout, Footer },
  data() {
    return {
      tabs: [
        "Observaciones generales",
        "Observaciones detalle",
        "Observaciones combinadas",
      ],
      activeTab:            "Observaciones generales",
      p_idPerfil:           0,
      resultados:           [],
      resultadosGenerales:  [],
      resultadosDetalle:    [],
      cargando:             false,
      itemsPerPage:         10,
      currentPageMain:      1,
      currentPageGenerales: 1,
      currentPageDetalle:   1,
      datosTramite:         "",
      showModalHelp:        false,
      orden: {
        main:      { campo: "planillaNumero", ascendente: true },
        generales: { campo: "planillaNumero", ascendente: true },
        detalle:   { campo: "planillaNumero", ascendente: true },
      },
      filtrosColumna: {
        main: {
          planilla: "", codigo: "", observacionTipo: "", obsEstandar: "",
          obsComplementaria: "", estadoAud: "", estadoDoc: "",
          respuesta: "", respuestaDescripcion: "", respondida: "",
        },
        generales: {
          planilla: "", observacionTipo: "", obsEstandar: "",
          obsComplementaria: "", estadoAud: "", estadoDoc: "",
          respuesta: "", respuestaDescripcion: "", respondida: "",
        },
        detalle: {
          planilla: "", codigo: "", observacionTipo: "", obsEstandar: "",
          obsComplementaria: "", estadoAud: "", estadoDoc: "",
          respuesta: "", respuestaDescripcion: "", respondida: "",
        },
      },
      filtros: {
        observacionTipo: "",
      },
    };
  },

  computed: {
    // ── Main ─────────────────────────────────────────────
    mainFiltrados() {
      const fc = this.filtrosColumna.main;
      const esGenerales = this.activeTab === "Observaciones generales";
      const lista = this.resultados.filter(r => {
        const p    = fc.planilla
          ? String(r.planillaNumero ?? "").toLowerCase().includes(fc.planilla.toLowerCase()) : true;
        const c    = (!esGenerales && fc.codigo)
          ? String(r.elementoCodigo ?? "").toLowerCase().includes(fc.codigo.toLowerCase()) : true;
        const ot   = fc.observacionTipo
          ? String(r.observacionTipo ?? "").toLowerCase().includes(fc.observacionTipo.toLowerCase()) : true;
        const oe   = fc.obsEstandar
          ? String(r.observacionDescripcion ?? "").toLowerCase().includes(fc.obsEstandar.toLowerCase()) : true;
        const oc   = fc.obsComplementaria
          ? String(r.descripcion ?? "").toLowerCase().includes(fc.obsComplementaria.toLowerCase()) : true;
        const ea   = fc.estadoAud ? (r.estadoAud ?? "") === fc.estadoAud : true;
        const ed   = fc.estadoDoc ? (r.estadoDoc ?? "") === fc.estadoDoc : true;
        const rs   = fc.respuesta
          ? String(r.respuesta ?? "").toLowerCase().includes(fc.respuesta.toLowerCase()) : true;
        const rd   = fc.respuestaDescripcion
          ? String(r.respuestaDescripcion ?? "").toLowerCase().includes(fc.respuestaDescripcion.toLowerCase()) : true;
        const resp = fc.respondida === "1" ? !!r.respuestaDescripcion
          : fc.respondida === "0" ? !r.respuestaDescripcion : true;
        return p && c && ot && oe && oc && ea && ed && rs && rd && resp;
      });
      return this._ordenarLista(lista, this.orden.main);
    },
    totalPagesMain() {
      return Math.max(1, Math.ceil(this.mainFiltrados.length / this.itemsPerPage));
    },
    pagedResultados() {
      const start = (this.currentPageMain - 1) * this.itemsPerPage;
      return this.mainFiltrados.slice(start, start + this.itemsPerPage);
    },

    // ── Generales ─────────────────────────────────────────
    generalesFiltrados() {
      const fc = this.filtrosColumna.generales;
      const lista = this.resultadosGenerales.filter(r => {
        const p    = fc.planilla
          ? String(r.planillaNumero ?? "").toLowerCase().includes(fc.planilla.toLowerCase()) : true;
        const ot   = fc.observacionTipo
          ? String(r.observacionTipo ?? "").toLowerCase().includes(fc.observacionTipo.toLowerCase()) : true;
        const oe   = fc.obsEstandar
          ? String(r.observacionDescripcion ?? "").toLowerCase().includes(fc.obsEstandar.toLowerCase()) : true;
        const oc   = fc.obsComplementaria
          ? String(r.descripcion ?? "").toLowerCase().includes(fc.obsComplementaria.toLowerCase()) : true;
        const ea   = fc.estadoAud ? (r.estadoAud ?? "") === fc.estadoAud : true;
        const ed   = fc.estadoDoc ? (r.estadoDoc ?? "") === fc.estadoDoc : true;
        const rs   = fc.respuesta
          ? String(r.respuesta ?? "").toLowerCase().includes(fc.respuesta.toLowerCase()) : true;
        const rd   = fc.respuestaDescripcion
          ? String(r.respuestaDescripcion ?? "").toLowerCase().includes(fc.respuestaDescripcion.toLowerCase()) : true;
        const resp = fc.respondida === "1" ? !!r.respuestaDescripcion
          : fc.respondida === "0" ? !r.respuestaDescripcion : true;
        return p && ot && oe && oc && ea && ed && rs && rd && resp;
      });
      return this._ordenarLista(lista, this.orden.generales);
    },
    totalPagesGenerales() {
      return Math.max(1, Math.ceil(this.generalesFiltrados.length / this.itemsPerPage));
    },
    pagedGenerales() {
      const start = (this.currentPageGenerales - 1) * this.itemsPerPage;
      return this.generalesFiltrados.slice(start, start + this.itemsPerPage);
    },

    // ── Detalle ───────────────────────────────────────────
    detalleFiltrados() {
      const fc = this.filtrosColumna.detalle;
      const lista = this.resultadosDetalle.filter(r => {
        const p    = fc.planilla
          ? String(r.planillaNumero ?? "").toLowerCase().includes(fc.planilla.toLowerCase()) : true;
        const c    = fc.codigo
          ? String(r.elementoCodigo ?? "").toLowerCase().includes(fc.codigo.toLowerCase()) : true;
        const ot   = fc.observacionTipo
          ? String(r.observacionTipo ?? "").toLowerCase().includes(fc.observacionTipo.toLowerCase()) : true;
        const oe   = fc.obsEstandar
          ? String(r.observacionDescripcion ?? "").toLowerCase().includes(fc.obsEstandar.toLowerCase()) : true;
        const oc   = fc.obsComplementaria
          ? String(r.descripcion ?? "").toLowerCase().includes(fc.obsComplementaria.toLowerCase()) : true;
        const ea   = fc.estadoAud ? (r.estadoAud ?? "") === fc.estadoAud : true;
        const ed   = fc.estadoDoc ? (r.estadoDoc ?? "") === fc.estadoDoc : true;
        const rs   = fc.respuesta
          ? String(r.respuesta ?? "").toLowerCase().includes(fc.respuesta.toLowerCase()) : true;
        const rd   = fc.respuestaDescripcion
          ? String(r.respuestaDescripcion ?? "").toLowerCase().includes(fc.respuestaDescripcion.toLowerCase()) : true;
        const resp = fc.respondida === "1" ? !!r.respuestaDescripcion
          : fc.respondida === "0" ? !r.respuestaDescripcion : true;
        return p && c && ot && oe && oc && ea && ed && rs && rd && resp;
      });
      return this._ordenarLista(lista, this.orden.detalle);
    },
    totalPagesDetalle() {
      return Math.max(1, Math.ceil(this.detalleFiltrados.length / this.itemsPerPage));
    },
    pagedDetalle() {
      const start = (this.currentPageDetalle - 1) * this.itemsPerPage;
      return this.detalleFiltrados.slice(start, start + this.itemsPerPage);
    },
  },

  watch: {
    activeTab() {
      this.currentPageMain      = 1;
      this.currentPageGenerales = 1;
      this.currentPageDetalle   = 1;
      this.filtrosColumna.main = {
        planilla: "", codigo: "", observacionTipo: "", obsEstandar: "",
        obsComplementaria: "", estadoAud: "", estadoDoc: "",
        respuesta: "", respuestaDescripcion: "", respondida: "",
      };
      this.filtrosColumna.generales = {
        planilla: "", observacionTipo: "", obsEstandar: "",
        obsComplementaria: "", estadoAud: "", estadoDoc: "",
        respuesta: "", respuestaDescripcion: "", respondida: "",
      };
      this.filtrosColumna.detalle = {
        planilla: "", codigo: "", observacionTipo: "", obsEstandar: "",
        obsComplementaria: "", estadoAud: "", estadoDoc: "",
        respuesta: "", respuestaDescripcion: "", respondida: "",
      };
      this.buscarDatos();
    },
  },

  mounted() {
    this.p_idPerfil  = window.sessionStorage.getItem("idPerfil");
    this.$refs.layoutRef.toggleProcesos();
    this.$refs.layoutRef.toggleReportes();
    this.$refs.layoutRef.toggleParametros();
    this.$refs.layoutRef.toggleAyuda();
    this.buscarDatos();
    this.datosTramite = sessionStorage.getItem("datosTramite");
//alert("2 idTramite: "+this.p_idtramite);
//alert("2 idServicio: "+this.p_idservicio);
//alert("2 estadoTramite: "+this.p_estadoTramite);
  },

  methods: {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
    ordenarPor(tabla, campo) {
      if (this.orden[tabla].campo === campo) {
        this.orden[tabla].ascendente = !this.orden[tabla].ascendente;
      } else {
        this.orden[tabla].campo = campo;
        this.orden[tabla].ascendente = true;
      }
      this.resetPagina(tabla);
    },
    iconOrden(tabla, campo) {
      if (this.orden[tabla].campo !== campo) return "⇅";
      return this.orden[tabla].ascendente ? "↑" : "↓";
    },
_ordenarLista(lista, orden) {
  const { campo, ascendente } = orden;
  return [...lista].sort((a, b) => {
    const va = a[campo] ?? "";
    const vb = b[campo] ?? "";

    // ── Ordenamiento numérico para planillaNumero ────────
    if (campo === 'planillaNumero') {
      const na = parseFloat(va);
      const nb = parseFloat(vb);
      if (!isNaN(na) && !isNaN(nb)) {
        return ascendente ? na - nb : nb - na;
      }
    }

    // ── Ordenamiento alfabético para el resto ────────────
    const cmp = String(va).localeCompare(String(vb), "es");
    return ascendente ? cmp : -cmp;
  });
},
    resetPagina(tabla) {
      if (tabla === "main")      this.currentPageMain      = 1;
      if (tabla === "generales") this.currentPageGenerales = 1;
      if (tabla === "detalle")   this.currentPageDetalle   = 1;
    },
    paginasVisibles(tabla) {
      const mapaTotal  = { main: this.totalPagesMain,  generales: this.totalPagesGenerales,  detalle: this.totalPagesDetalle  };
      const mapaActual = { main: this.currentPageMain, generales: this.currentPageGenerales, detalle: this.currentPageDetalle };
      const total  = mapaTotal[tabla];
      const actual = mapaActual[tabla];
      const delta  = 2;
      const rango  = [];
      for (let i = Math.max(2, actual - delta); i <= Math.min(total - 1, actual + delta); i++) {
        rango.push(i);
      }
      if (rango.length && rango[0] > 2)                        rango.unshift("...");
      if (rango.length && rango[rango.length - 1] < total - 1) rango.push("...");
      const paginas = [1];
      rango.forEach(p => paginas.push(p));
      if (total > 1) paginas.push(total);
      return paginas;
    },

    // ── Datos ─────────────────────────────────────────────
    async buscarDatos() {
      this.cargando = true;
      if (this.activeTab === "Observaciones combinadas") {
        await this.fetchCombinadas();
      } else {
        const endpoint = this.activeTab === "Observaciones generales"
          ? "/vwplaobss/buscar"
          : "/vwpladetobss/buscar";
        try {
          const { data } = await api.get(endpoint, {
            params: {
              idTramite:       this.p_idtramite,
              observacionTipo: this.filtros.observacionTipo || null,
            },
          });
          this.resultados      = Array.isArray(data) ? data : [];
          this.currentPageMain = 1;
        } catch (e) {
          console.error("Error al cargar datos:", e);
          this.resultados = [];
        } finally {
          this.cargando = false;
        }
      }
    },
    async fetchCombinadas() {
      try {
        const params = {
          idTramite:       this.p_idtramite,
          observacionTipo: this.filtros.observacionTipo || null,
        };
        const [generales, detalle] = await Promise.all([
          api.get("/vwplaobss/buscar",    { params }),
          api.get("/vwpladetobss/buscar", { params }),
        ]);
        this.resultadosGenerales  = Array.isArray(generales.data) ? generales.data : [];
        this.resultadosDetalle    = Array.isArray(detalle.data)   ? detalle.data   : [];
        this.currentPageGenerales = 1;
        this.currentPageDetalle   = 1;
      } catch (e) {
        console.error("Error al cargar datos combinados:", e);
        this.resultadosGenerales = [];
        this.resultadosDetalle   = [];
      } finally {
        this.cargando = false;
      }
    },

    // ── Exportar Excel ────────────────────────────────────
    exportToExcel() {
      const headers = [
        "Número", "Cédula", "Nombre", "Fecha desde", "Fecha hasta",
        "Fecha atención", "Código", "Tipo", "Descripción",
        "Observación estándar", "Observación complementaria",
        "Estado A.M.", "Estado G.D.", "Respuesta", "Desc. respuesta",
      ];
      if (this.activeTab === "Observaciones combinadas") {
        if (!this.resultadosGenerales.length && !this.resultadosDetalle.length) {
          Swal.fire({ title: "Advertencia", text: "No hay datos para exportar.", icon: "warning", confirmButtonText: "OK" });
          return;
        }
        const data = [
          ...this.resultadosGenerales.map(row => [
            row.planillaNumero || "", row.planillaCedula || "", row.planillaNombre || "",
            this.getFormattedDate(row.planillaFechaDesde) || "",
            this.getFormattedDate(row.planillaFechaHasta) || "",
            "", "", row.observacionTipo || "", "",
            row.observacionDescripcion || "", row.descripcion || "",
            row.estadoAud || "", row.estadoDoc || "",
            row.respuesta || "", row.respuestaDescripcion || "",
          ]),
          ...this.resultadosDetalle.map(row => [
            row.planillaNumero || "", row.planillaCedula || "", row.planillaNombre || "",
            this.getFormattedDate(row.planillaFechaDesde) || "",
            this.getFormattedDate(row.planillaFechaHasta) || "",
            this.getFormattedDate(row.fechaAtencion) || "",
            row.elementoCodigo || "", row.observacionTipo || "", row.elementoNombre || "",
            row.observacionDescripcion || "", row.descripcion || "",
            row.estadoAud || "", row.estadoDoc || "",
            row.respuesta || "", row.respuestaDescripcion || "",
          ]),
        ];
        const ws = XLSX.utils.aoa_to_sheet([headers, ...data]);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Observaciones");
        XLSX.writeFile(wb, `observaciones_combinadas_${this.p_idtramite}.xlsx`);
      } else {
        if (!this.resultados.length) {
          Swal.fire({ title: "Advertencia", text: "No hay datos para exportar.", icon: "warning", confirmButtonText: "OK" });
          return;
        }
        const esGen = this.activeTab === "Observaciones generales";
        const data = this.resultados.map(row => [
          row.planillaNumero || "", row.planillaCedula || "", row.planillaNombre || "",
          this.getFormattedDate(row.planillaFechaDesde) || "",
          this.getFormattedDate(row.planillaFechaHasta) || "",
          esGen ? "" : this.getFormattedDate(row.fechaAtencion) || "",
          esGen ? "" : row.elementoCodigo || "",
          row.observacionTipo || "",
          esGen ? "" : row.elementoNombre || "",
          row.observacionDescripcion || "", row.descripcion || "",
          row.estadoAud || "", row.estadoDoc || "",
          row.respuesta || "", row.respuestaDescripcion || "",
        ]);
        const ws = XLSX.utils.aoa_to_sheet([headers, ...data]);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Observaciones");
        XLSX.writeFile(wb, `observaciones_${this.p_idtramite}.xlsx`);
      }
    },

    // ── Marcar revisado ───────────────────────────────────
    async marcarRevisado(tipo, id) {
      if (!id) return;
      const endpoint = tipo === "generales"
        ? `/plaobss/revisado/${id}`
        : `/pladetobss/revisado/${id}`;
      try {
        await api.put(endpoint);
        const actualizarLista = (lista) => {
          const campo = tipo === "generales" ? "idPlaObs" : "idPlaDetObs";
          const item  = lista.find(r => r[campo] === id);
          if (item) item.revisado = item.revisado === 1 ? 0 : 1;
        };
        if (tipo === "generales") {
          actualizarLista(this.resultadosGenerales);
          actualizarLista(this.resultados);
        } else {
          actualizarLista(this.resultadosDetalle);
          actualizarLista(this.resultados);
        }
      } catch (e) {
        console.error("Error al marcar revisado:", e);
        Swal.fire({
          title: "Error",
          text: e.response?.data || "No se pudo actualizar el registro.",
          icon: "error",
          confirmButtonText: "Cerrar",
        });
      }
    },
    handleRowClick(event, idPlanilla) {
      if (event.target.tagName === "SELECT" || event.target.tagName === "OPTION") return;
      if ([1, 17, 18, 19, 20].includes(Number(this.p_idPerfil))) {
        this.abrirEditar(idPlanilla);
      }
    },
    abrirEditar(idPlanilla) {
      if (idPlanilla == null) return;

      const params = new URLSearchParams({
        idTramite:     this.p_idtramite,
        idServicio:    this.p_idservicio,
        estadoTramite: this.p_estadoTramite,
        idPlanilla,
        tipoConsulta:  'REPORTE',
      });

      window.open(`/planillaformpopup?${params.toString()}`, '_blank');
    },
  },
};
</script>

<style src="@/assets/css/tabs.css" scoped></style>
<style scoped>
.nav-tabs .nav-link.active {
  background-color: #0d6efd;
  color: #fff !important;
  border-color: #0d6efd #0d6efd #fff;
}
.table-hover tbody tr {
  cursor: pointer;
}
.th-sort {
  cursor: pointer;
  user-select: none;
  white-space: nowrap;
}
.th-sort:hover {
  background-color: #3d5166;
}
thead tr:nth-child(2) th {
  cursor: default;
  font-weight: normal;
  padding: 4px 6px;
}
thead tr:nth-child(2) th input,
thead tr:nth-child(2) th select {
  font-weight: normal;
  color: #212529;
}
</style>